import React, { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import lowerCase from 'lodash/lowerCase';

import { Box } from '@lyearn/ui';
import { Modal } from '@/components/Modals';
import { ModalVariant } from '@/components/Modals/types';

import { VisibilitySettingsFormFieldProps } from '../../types';
import LegacyVisibilitySettingsFormField from '../LegacyVisibilitySettingsFormField';
import { VisibilitySettingsModalProps } from './types';

function VisibilitySettingsModal(props: VisibilitySettingsModalProps) {
  const { t } = useTranslation(['VisibilitySetting', 'Group']);
  const { visibilitySettings, onSubmit, contentName, onClose, showInfoTooltip = true } = props;
  const [settings, setSettings] = useState(visibilitySettings);

  const onModalSubmit = useCallback(() => {
    onSubmit(settings);
    onClose();
  }, [onSubmit, settings, onClose]);

  const overrides: VisibilitySettingsFormFieldProps['overrides'] = useMemo(
    () => ({
      restrictedContent: { showInfoTooltip },
    }),
    [showInfoTooltip],
  );

  return (
    <Modal
      action={{
        text: t('Common:Actions.SaveSettings'),
        onSubmit: onModalSubmit,
        discardText: t('Common:Cancel'),
      }}
      header={{
        title: t('VisibilitySetting:VisibilitySettings'),
        description: t('VisibilitySetting:VisibilitySettingsDescription', {
          contentName: lowerCase(contentName),
        }),
      }}
      variant={ModalVariant.FullHeight}
      onClose={onClose}>
      <Box className="flex flex-1 flex-col px-28 pb-128">
        <LegacyVisibilitySettingsFormField
          overrides={overrides}
          value={settings}
          onChange={setSettings}
        />
      </Box>
    </Modal>
  );
}

export default VisibilitySettingsModal;
